import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { OELogSettingsService } from "app/order-entry/services/basic/oe-log-settings.service";
import { OENInputControl } from "../../data/enums/oe-input-control.enum";
import { OENPanel } from "../../data/enums/oe-panel.enum";
import { OEInputModel } from "../../data/models/oe-input.model";
import { ICDTransportModel } from "../../data-idc/coordination/icd-transport.model";

@Injectable()
export class OELoggerService {
  /**
   * logger is instanced here as OELoggerService is not in the directory of callee
   */
  protected logger;

  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(private settings: OELogSettingsService) {
    // fallback to OELoggerService directory if .for() is skipped by callee
    this.logger = LoggerService.for(__dirname);
  }

  for(dirname) {
    let oeLogger = new OELoggerService(this.settings);
    oeLogger.logger = LoggerService.for(dirname);
    return oeLogger;
  }

  /**********************************************************************/
  /* DEBUG LOGGING  */

  public outputExtendedLogging(value: string, dump: any = null): void {
    if (this.settings.debug.extendedLogging) {
      if (dump != null && this.settings.debug.dumpModelsLogging) {
        this.logger.out.info(value + " %O", dump);
        if (
          dump != null &&
          dump.rootOrder != null &&
          Array.isArray(dump.rootOrder.strategyParameters) &&
          dump.rootOrder.strategyParameters.length > 0
        ) {
          this.logger.out.info("--- Strategy DUMP ----");
          for (let item of dump.rootOrder.strategyParameters) {
            this.logger.out.info("param: " + "%O", item);
          }
        }
      } else {
        this.logger.out.info(value);
      }
    }
  }

  public outputRateLogging(value: string, dump: any = null): void {
    if (this.settings.debug.extendedLogging_rate) {
      if (dump != null && this.settings.debug.dumpModelsLogging_rate) {
        this.logger.out.warn(value + " %O", dump);
      } else {
        this.logger.out.warn(value);
      }
    }
  }

  public outputInputControlErrors(
    refId: string,
    errors: Array<OEInputModel>,
    validationType: string = null,
    orderId: string = null,
  ): void {
    if (Array.isArray(errors) && errors.length > 0) {
      let errorsText: string = "";
      let counter: number = 0;
      for (let error of errors) {
        if (error instanceof OEInputModel) {
          errorsText +=
            `(${++counter}) Panel: ${OENPanel[error.panel]} | Input: ${
              OENInputControl[error.input]
            } => ` +
            (error.value != null && error.value instanceof ICDTransportModel
              ? `Algo icdId: ${error.value.icdId} value: ${error.value.value} errorMsg: ${error.value.errorMsg} \n`
              : `Value: ${error.value} \n`);
        }
      }
      this.logger.out.warn(
        `UI-MAIN: Order [${typeof refId === "string" ? refId : "Unknown"}]` +
          `${typeof orderId == "string" ? "(" + orderId + ")" : ""} ${
            typeof validationType == "string" ? validationType + " " : ""
          }validation ` +
          `found ${counter} Input Errors: \n${errorsText}`,
      );
    }
  }

  public outputDevLogToConsole(value: string, warning: boolean = false, dump: any = null): void {
    if (this.settings.debug.extendedLogging) {
      if (warning) {
        if (dump != null) {
          this.logger.out.warn("DEV-LOG: " + value, dump);
        } else {
          this.logger.out.warn("DEV-LOG: " + value);
        }
      } else {
        if (dump != null) {
          this.logger.out.info("DEV-LOG: " + value, dump);
        } else {
          this.logger.out.info("DEV-LOG: " + value);
        }
      }
    }
  }

  public outputRateLogToConsole(value: string, warning: boolean = false, dump: any = null): void {
    if (this.settings.debug.extendedLogging_rate) {
      if (warning) {
        if (dump != null) {
          this.logger.out.warn("RATE-LOG: " + value, dump);
        } else {
          this.logger.out.warn("RATE-LOG: " + value);
        }
      } else {
        if (dump != null) {
          this.logger.out.info("RATE-LOG: " + value, dump);
        } else {
          this.logger.out.info("RATE-LOG: " + value);
        }
      }
    }
  }

  public isExtendedLoggingEnabled(): boolean {
    return this.settings.debug.extendedLogging;
  }
}
